import React from "react";

const ColorLabel = ({ bgColor, labelText }) => {
  return (
    <div
      style={{
        position: "relative",
        // background: "#f00",
        width: 12,
        height: 12,
        borderRadius: "50%",
        // marginBottom: 20,
        backgroundColor: bgColor,
        fontSize:".85rem"
      }}
    >
      <span
        style={{
          position: "absolute",
          left: "28px",
          top: "-3px",
          width:"250px"
        }}
      >
        {labelText}
      </span>
    </div>
  );
};

export default ColorLabel;
